export default {

  init(){
    // Jewelry carousel
    $('.owl-carousel').owlCarousel({
      nav: true,
      navText: ['', ''],
      dots: false,
      items: 3,
      autoplay: false,
      lazyLoad: true,
      responsive:{
        0:{
          items:1,
        },
        600:{
          items:3,
        },
        1000:{
          items:3,
        },
      },
      margin: 50,
    });


    $('.staff-item').hover(function(){
      $('.staff-item').not(this).addClass('not-hover');
    }, function(){
      $('.staff-item').removeClass('not-hover');
    });

    // Replace contact link
    if( $('#contact-form').length > 0 ){
      $('#contact-col .btn').attr('href', '#contact-form').click(function(){

        $(window).scrollTo($('#contact-form'), 1200,{
          axis: 'y',
          offset: -80,
        });

        return false;
      });
    }


    $('.jewelry-slide a').fancybox();

  },

  finalize(){

    //$('.fullcoveredvideo video').play();

  },

};



// WEBPACK FOOTER //
// ./scripts/routes/home.js